export type Role = 'admin' | 'user' | 'subuser';

export interface Session {
  userId: string;
  role: Role;
  orgId: string | null;
  name: string;
}

interface Credential {
  username: string;
  password: string;
  userId: string;
  role: Role;
  orgId: string | null;
  name: string;
}

const SESSION_KEY = 'cooptest.session';

const credentials: Credential[] = [
  {
    username: 'admin@cooptest.com',
    password: 'AdminPass123',
    userId: 'admin-001',
    role: 'admin',
    orgId: null,
    name: 'Platform Admin',
  },
  {
    username: 'user@northwind.org',
    password: 'UserPass123',
    userId: 'user-001',
    role: 'user',
    orgId: 'org-001',
    name: 'Northwind Org User',
  },
  {
    username: 'subuser@northwind.org',
    password: 'SubuserPass123',
    userId: 'subuser-001',
    role: 'subuser',
    orgId: 'org-001',
    name: 'Northwind Subuser',
  },
];

function readSession(): Session | null {
  const raw = localStorage.getItem(SESSION_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as Session;
  } catch (error) {
    console.error(error);
    return null;
  }
}

export function getSession(): Session | null {
  return readSession();
}

export function authenticate(username: string, password: string): Session | null {
  const match = credentials.find(
    cred => cred.username.toLowerCase() === username.toLowerCase() && cred.password === password
  );
  if (!match) return null;
  const session: Session = {
    userId: match.userId,
    role: match.role,
    orgId: match.orgId,
    name: match.name,
  };
  localStorage.setItem(SESSION_KEY, JSON.stringify(session));
  return session;
}

export function clearSession() {
  localStorage.removeItem(SESSION_KEY);
}

export function getCredentialHints() {
  return credentials.map(({ username, password, role }) => ({ username, password, role }));
}
